import { spawn } from 'redux-saga/effects'

import * as wordpress from '../wordpress'
import * as auth from '../auth'
import * as activation from '../activation'
import * as grs from '../grs'
import * as confirmation from '../confirmation'
import * as extending from '../extending'
import * as sfproxy from '../sfproxy'
import * as map from '../map'
import * as creditCards from '../credit-cards'
import * as vehicles from '../dashboard-vehicles'
import * as search from '../search'
import * as account from '../dashboard-account'
import * as header from '../header'
import * as loginAndSignup from '../login-and-signup'
import * as dashboardTransactions from '../dashboard-transactions'
import * as dashboardSubscriptions from '../dashboard-subscriptions'
import * as purchaseFlowCanada from 'subscription-flow/canada'
import * as carParks from '../car-parks'
import * as booking from '../booking'
import * as dashboard from '../dashboard'
import * as onDemandParking from '../dashboard-on-demand-parking'
import * as analytics from '../analytics'
import i18n from '../i18n/sagas'
import news from '../news/sagas'
import onStreet from '../on-street/sagas'
import npsSaga from '../nps-view/sagas'
import waitingList from 'subscription-flow/waitlist/sagas'
import scanticketSaga from '../scanticket/sagas'
import * as googlePay from '../credit-cards/google-pay'

export default function* rootSaga() {
    yield spawn(activation.rootSaga)
    yield spawn(wordpress.rootSaga)
    yield spawn(auth.rootSaga)
    yield spawn(grs.rootSaga)
    yield spawn(confirmation.rootSaga)
    yield spawn(extending.rootSaga)
    yield spawn(search.rootSaga)
    yield spawn(sfproxy.rootSaga)
    yield spawn(creditCards.rootSaga)
    yield spawn(vehicles.rootSaga)
    yield spawn(map.rootSaga)
    yield spawn(account.rootSaga)
    yield spawn(header.rootSaga)
    yield spawn(loginAndSignup.rootSaga)
    yield spawn(dashboardTransactions.rootSaga)
    yield spawn(dashboardSubscriptions.rootSaga)
    yield spawn(purchaseFlowCanada.rootSaga)
    yield spawn(carParks.rootSaga)
    yield spawn(booking.rootSaga)
    yield spawn(dashboard.rootSaga)
    yield spawn(onDemandParking.rootSaga)
    yield spawn(analytics.sagas.default)
    yield spawn(i18n)
    yield spawn(waitingList)
    yield spawn(news)
    yield spawn(onStreet)
    yield spawn(npsSaga)
    yield spawn(scanticketSaga)
    yield spawn(googlePay.rootSaga)
}
